import { css } from 'styled-components';
import colors from './colors';

/**
 * Tokens compartilhados das peças do Match das Licitações.
 * Protótipo: Figma mqItdOcLwG2pZQzs3Dl3a5 — faixa do card (4:4628) e banner do topo (4:4151).
 */

/** Gradiente "IA" do design system (azul -> verde). */
export const iaGradient = `linear-gradient(90deg, ${colors.$primary} 0%, ${colors.$primary_green} 100%)`;

/** Mesmo gradiente a 5% de opacidade — fundo da faixa/banner. */
export const iaGradientSurface =
  'linear-gradient(90deg, rgba(0, 123, 255, 0.05) 0%, rgba(0, 159, 121, 0.05) 100%)';

/** Azul/600 do design system — usado nas pills de indicadores. */
export const matchPillColor = '#366793';

/** Superfície das peças de Match: borda azul, fundo em gradiente suave e sombra difusa. */
export const matchSurface = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${colors.$primary};
  border-radius: 4px;
  background: ${iaGradientSurface};
  box-shadow: 0 0 10px rgba(94, 118, 172, 0.1);
`;

/** Botão outline azul ("Assistir vídeo explicativo"). */
export const matchOutlineButton = css`
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 8px 12px;
  border: 1px solid ${colors.$primary};
  border-radius: 4px;
  background: transparent;
  color: ${colors.$primary};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.3125px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: rgba(0, 123, 255, 0.08);
  }
`;

/**
 * Botão "Personalizar": borda e texto em gradiente.
 * A borda usa duas camadas de background (padding-box + border-box) e o texto
 * usa background-clip, com `color` de fallback para navegadores sem suporte.
 * O preenchimento precisa ser opaco: uma camada translúcida deixa o gradiente
 * da borda vazar e cobrir o botão inteiro.
 */
export const matchGradientButton = css`
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 8px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-image: linear-gradient(${colors.$white}, ${colors.$white}), ${iaGradient};
  background-origin: padding-box, border-box;
  background-clip: padding-box, border-box;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.3125px;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: filter 0.15s ease;

  span {
    color: ${colors.$primary};
    background: ${iaGradient};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &:hover {
    filter: brightness(0.97);
  }
`;
